import type { MouseEvent } from 'react';
import { ReactComponent as CopyIcon } from '@elementary/common-ui/assets/copy.svg';
import { IconButton } from '@elementary/common-ui/components';
import { SxProps, Tooltip } from '@mui/material';
import useSnackbar from 'shared/hooks/useSnackbar';

type Props = {
  sx?: SxProps;
  className?: string;
  textToCopy: string;
  iconSize?: number;
  disabled?: boolean;
};

const CopyButton = ({
  sx,
  className,
  textToCopy,
  iconSize = 16,
  disabled,
}: Props) => {
  const { openSnackbar } = useSnackbar();

  const handleCopyClick = (e: MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(textToCopy);
    openSnackbar({ message: 'Copied to clipboard' });
  };

  return (
    <Tooltip title="Copy">
      <IconButton
        aria-label="Copy"
        className={className}
        sx={sx}
        onClick={handleCopyClick}
        disabled={disabled}
      >
        <CopyIcon width={iconSize} height={iconSize} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
